import React, {useEffect} from "react";
import {useParams, useSearchParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import SubHeader from "../../components/header/SubHeader";
import {capitalize} from "../../components/Utility";
import {fetchAllIncomeProducts, resetEditStatus, resetCreateStatus} from "../../store/income-product-slice";
import Table from "../../components/common/table/Table";
import {getTableColumns, getTableData} from "../../models/incomeProductModel";
import ActionButton from "../../components/actions/ActionButton";
import ImportExportButton from "../../components/importExport/ImportExportButton";

const IncomeProductView = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const incomeType = params.incomeType;
    const [searchParams] = useSearchParams();
    const userRole = useSelector((state) => state.auth.selectedRole);

    const {
        items,
        status,
    } = useSelector(state => state.menu.transactionType);

    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;

    const {
        items: incomeProducts,
        fetchStatus,
        createStatus,
        editStatus,
        pagination,
        error
    } = useSelector(state => state.incomeProduct);

    useEffect(() => {
        if (status === "success" && items.length > 0 && incomeType) {
            const match = items.find(
                (item) => item.name.toLowerCase() === incomeType.toLowerCase()
            );

            if (match?._id) {
                dispatch(fetchAllIncomeProducts({
                    ...userRole,
                    incomeTypeId: match._id,
                    page: initialPage,
                    limit: initialLimit
                }));
            }
        }
    }, [dispatch, userRole, initialPage, initialLimit, items, incomeType, status]);

    useEffect(() => {
        if (editStatus === "success") dispatch(resetEditStatus());
        if (createStatus === "success") dispatch(resetCreateStatus());
    }, [dispatch, editStatus, createStatus]);

    const incomeTypeId = items.find(
        (item) => item.name.toLowerCase() === incomeType.toLowerCase()
    )?._id;

    const tableColumns = getTableColumns();
    const tableData = getTableData({items: incomeProducts});

    return (
        <>
            <SubHeader title={`All ${capitalize(params.incomeType)} Products`}>
                <ImportExportButton ttid={incomeTypeId} listName={capitalize(params.incomeType)}/>
                <ActionButton
                    permissions={['RestaurantAdmin', 'RestaurantOwner']}
                    to="add"
                    className="btn-sm bg-primary bg-opacity-50">Add new</ActionButton>
            </SubHeader>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" &&
                <Table className="mobile-responsive" columns={tableColumns} data={tableData} pagination={pagination}/>}
        </>
    );
}
export default IncomeProductView;
